export const styles = {
    TITLE_STYLE: 'font-weight: bold; font-size: 12px; text-decoration: underline;',
    WARNING_STYLE: 'color: red; font-weight: bold;',
    INFO_STYLE: 'color: black'
}

export const limits = {
    NUMBER_OF_PAGES_LIMIT: 300,
    NUMBER_OF_COMPONENTS_LIMIT: 6000,
    NUMBER_OF_COMPONENTS_PER_PAGE_LIMIT: 100,
    NUMBER_OF_CHILD_WITH_SAME_TYPE: 50
}

export const pagesConsts = {
    UNKNOWN_PAGE: 'unknown',
    DATA_NAMESPACE: 'data'
}

export const EMPTY_STRING = ''

export const titles = {
    SUSPICIOUS_PAGES_TITLE: 'suspicious pages in',
    NUMBER_OF_PAGES_TITLE: 'total number of pages',
    NUMBER_OF_COMPONENTS_TITLE: 'total number of components',
    SUSPICIOUS_COMPONENTS_TITLE: 'Suspicious Components in',
    APPS_STATE_TITLE: 'Apps state'
}
